import { Component } from 'preact'
import Button from 'preact-material-components/Button'
import { connect } from 'preact-redux'
import { withNamespaces } from 'react-i18next'
import { createOrder } from '../../modules/createOrder'
import { selectRoomsForPayload } from '../../selectors/shoppingCardSelector'
import Credential from '../Credential'
import ArrowLeftIcon from '../Icons/ArrowLeftIcon'
import ShoppingCart from '../ShoppingCart'
import CustomerForm from './CustomerForm'
import styles from './CustomerInfoLayout.scss'

@connect(
    state => ({ rooms: selectRoomsForPayload(state) }),
    { createOrder }
)
class CustomerInfoLayout extends Component {
    handleCreateOrder = (name, telephone, email, remarks) => {
        const { rooms } = this.props
        const customer = { name, telephone, email, remarks }

        this.props.createOrder({ customer, rooms }).then(() => this.props.onGoNext())
    }

    handleNewSearchClick = () => {
        this.props.onNewSearch()
    }

    render() {

        const { t } = this.props

        return (
            <div class={styles.wrapper}>
                <Button class={styles.newSearchButton} onClick={this.handleNewSearchClick}>
                    <ArrowLeftIcon />
                    {t('CustomerInfoLayout.newsearch')}
                </Button>

                <div class={styles.customerInfoLayout}>
                    <div class={styles.customerInfo}>
                        <CustomerForm onSubmit={this.handleCreateOrder} />
                    </div>

                    <div class={styles.shoppingCart}>
                        <ShoppingCart withoutNextButton />
                    </div>
                </div>

                <Credential />
            </div>
        )
    }
}

export default withNamespaces()(CustomerInfoLayout)


// WEBPACK FOOTER //
// ./components/CustomerInfoLayout/CustomerInfoLayout.js